/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'save': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><polyline pid="0" points="21.5 11 13 20.5 10 17.5"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/save.js